import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';

export function createSimplePieChart(amChartsService: AmChartsService,
    divId: string,
    labelField: string,
    valueField: string,
    colors: string[]): AmChart {
    const chart = amChartsService.makeChart(divId, {
        'type': 'pie',
        'hideCredits': true,
        'startDuration': 0,
        'theme': 'light',
        'dataProvider': [{ key: 'Test', value: 50 }],
        'labelsEnabled': true,
        'outlineAlpha': 0.4,
        'groupPercent': 5,
        'groupedTitle': 'Other',
        'valueField': valueField,
        'labelField': labelField,
        'titleField': labelField,
        'showZeroSlices': false,
        'precision': 2,
        'autoMargins': false,
        'labelRadius': 2,
        'labelText': '[[title]]',
        'fontSize': 8,
        'colors': colors,
        // 'legend': {
        //     'position': 'bottom',
        //     'autoMargins': false,
        //     'marginTop': 0,
        //     'switchable': false,
        //     'markerType': 'circle',
        //     'align': 'center',
        //     'maxColumns': 2,
        //     // 'marginRight': 10,
        //     // 'marginBottom': 40,
        //     // 'marginLeft': 40,
        //     // 'valueFunction': (item) => {
        //     //     return item.dataContext['percents'] + '% (' + item.dataContext['RawAmount'] + ')';
        //     // },
        //     // 'labelText': '',
        //     // 'valueText': '[[percents]]% ([[RawAmount]])',
        //     // 'divId': 'explainlegenddiv'
        // },
        // 'marginTop': 0,
        // 'marginBottom': 20,
        // 'marginLeft': 20,
        // 'marginRight': 20,
        // 'pullOutRadius': 10,
    });
    return chart;
}


